import { render, staticRenderFns } from "./SiteSettingIndex.vue?vue&type=template&id=ad80844e&scoped=true&"
import script from "./SiteSettingIndex.vue?vue&type=script&lang=js&"
export * from "./SiteSettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./SiteSettingIndex.vue?vue&type=style&index=0&id=ad80844e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad80844e",
  null
  
)

export default component.exports